export default __webpack_public_path__ + "static/media/AlecBaldwin.178e24c4.jpg";